var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.readMode')}},[_c('el-switch',{model:{value:(_vm.optionModel.readMode),callback:function ($$v) {_vm.$set(_vm.optionModel, "readMode", $$v)},expression:"optionModel.readMode"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }